module.exports = __webpack_public_path__ + "branding_identity_stationary_design_rvcnn_logo_business_card_fashion_corporate.jpg?14a8c235ccca3edc98c68ec92bd12a82";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/branding_identity_stationary_design_rvcnn_logo_business_card_fashion_corporate.jpg
// module id = 93
// module chunks = 0